import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-b-0" data-id="element-255">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-5 flex items-center justify-between text-left hover:text-orange-600 transition-colors" data-id="element-256">
        <span className="font-medium text-lg text-navy-900" data-id="element-257">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-258">
          <ChevronDownIcon className="w-5 h-5 text-orange-600 flex-shrink-0" data-id="element-259" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-260">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeInOut'
      }} data-id="element-261">
            <p className="pb-5 text-gray-700 leading-relaxed" data-id="element-262">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}